import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { getLogsData } from "../actions/getLogosDataAction";

const initialState = {
    Object: null,
    loading: 'idle',
    hasError: false,
    errorMessage: ''
}
const logsSlice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        resetState: () => {

            return initialState;
        }

    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        })
            .addCase(getLogsData.pending, (state) => {
                state.loading = 'pending';
                state.hasError = false
            })
            .addCase(getLogsData.fulfilled, (state, action) => {
                state.loading = 'succeeded';
                state.hasError = false;
                state.Object = action.payload;
                state.errorMessage = ""


            })
            .addCase(getLogsData.rejected, (state, action) => {
                state.loading = 'failed';
                state.hasError = true;
                state.errorMessage = action.payload
            })
    }
});
export const { deleteFileById, resetState } = logsSlice.actions;

export default logsSlice.reducer;